import service from '@/utils/request'

//登录
export function login(param) {
	return service.request({
		method: 'post',
		url: '/app1/login',
		data: param
	})
}
// 获取验证码
export function getCodeImg() {
	return service.request({
		url: '/app1/captchaImage',
		method: 'get'
	})
}
// 退出方法
export function logout() {
	return service.request({
		url: '/app/logout',
		method: 'get'
	})
}

//获取角色、用户、权限信息
export function getUserInfo() {
	return service.request({
		method: 'get',
		url: '/app/getUserInfo',
	})
}
